"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Lang_js_1 = require("../Lang.js");
var mountIsland_1 = require("../mountIsland");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var lang = ((_b = (_a = document.getElementById('student-downloads')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.lang) || 'en';
var isSpanish = lang === 'es';
var map = {
    jan: isSpanish ? 'ENE' : 'JAN',
    feb: 'FEB',
    mar: 'MAR',
    apr: isSpanish ? 'ABR' : 'APR',
    may: 'MAY',
    jun: 'JUN',
    jul: 'JUL',
    aug: isSpanish ? 'AGO' : 'AUG',
    sep: 'SEP',
    oct: 'OCT',
    nov: 'NOV',
    dec: isSpanish ? 'DIC' : 'DEC',
};
var MONTHS = [
    map.jan, map.feb, map.mar, map.apr, map.may, map.jun,
    map.jul, map.aug, map.sep, map.oct, map.nov, map.dec,
];
function getFormattedDatePart(year, month) {
    var monthIndex = parseInt(month, 10) - 1;
    if (monthIndex < 0 || monthIndex > 11)
        return '';
    return "".concat(MONTHS[monthIndex], " ").concat(year);
}
// SATs expire; a perpetual entry arrives as 0000-00-00 and shows no date.
function formatDate(dateString) {
    if (!dateString || !dateString.includes('-'))
        return '';
    var _a = dateString.split('-'), year = _a[0], month = _a[1], day = _a[2];
    return "".concat(month, "/").concat(day, "/").concat(year);
}
function formatDownloadTitle(name, type, file, fileid) {
    if (type !== 'SAT') {
        return { datePart: '', titlePart: name };
    }
    var datePart = '';
    var idMatch = fileid === null || fileid === void 0 ? void 0 : fileid.match(/(\d{4})-(\d{1,2})/);
    if (idMatch) {
        var year = idMatch[1], month = idMatch[2];
        datePart = getFormattedDatePart(year, month.padStart(2, '0'));
    }
    if (!datePart && file) {
        var fileMatchAlpha = file.match(/SAT[_ ]([A-Za-z]{3,9})(\d{4})/);
        var fileMatchNumeric = file.match(/SAT[_ ](\d{4})-(\d{2})/);
        if ((fileMatchAlpha === null || fileMatchAlpha === void 0 ? void 0 : fileMatchAlpha.length) === 3) {
            var monthAlpha = fileMatchAlpha[1], year = fileMatchAlpha[2];
            var shortMonth = monthAlpha.slice(0, 3).toLowerCase();
            if (map[shortMonth]) {
                datePart = "".concat(map[shortMonth], " ").concat(year);
            }
        }
        else if ((fileMatchNumeric === null || fileMatchNumeric === void 0 ? void 0 : fileMatchNumeric.length) === 3) {
            var year = fileMatchNumeric[1], month = fileMatchNumeric[2];
            datePart = getFormattedDatePart(year, month.padStart(2, '0'));
        }
    }
    if (!datePart && name) {
        var match = name.match(/\(([^)]+)\)$/);
        if (match) {
            datePart = match[1];
        }
    }
    return { datePart: datePart, titlePart: name };
}
function GetStudentDownloads() {
    var _a = (0, react_1.useState)([]), downloads = _a[0], setDownloads = _a[1];
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)('sat'), tab = _c[0], setTab = _c[1];
    (0, react_1.useEffect)(function () {
        axios_1.default.get('/api/v2/students/downloads')
            .then(function (response) {
            var data = response.data.downloads;
            setDownloads(data);
            // Open on SATs when present, otherwise fall back to Discourses.
            setTab(data.some(function (d) { return d.type === 'SAT'; }) ? 'sat' : 'discourse');
            setIsLoading(false);
        })
            .catch(function (error) {
            console.log(error);
            setIsLoading(false);
        });
    }, []);
    if (isLoading)
        return react_1.default.createElement("div", null, "Loading...");
    if (downloads.length === 0) {
        return (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: (0, Lang_js_1.__)("Dear Friend,<br/><br/>" +
                    "Your account appears to be activated, but is not registered as an active subscriber. " +
                    "Please contact <a href='mailto:order@msia.org'>order@msia.org</a> or call the MSIA " +
                    "Products and Service Department at (323) 737-4055 for assistance.<br/><br/>" +
                    "God Bless you,<br/>MSIA - Products and Service Department") } }));
    }
    var sats = downloads.filter(function (d) { return d.type === 'SAT'; });
    var discourses = downloads.filter(function (d) { return d.type !== 'SAT'; });
    var showToggle = sats.length > 0 && discourses.length > 0;
    var visible = tab === 'sat' ? sats : discourses;
    var pillSx = function (active) { return ({
        flex: 1,
        cursor: 'pointer',
        border: '1px solid #152041',
        borderRadius: '6px',
        padding: '8px 16px',
        fontSize: '0.95rem',
        fontWeight: 600,
        textAlign: 'center',
        backgroundColor: active ? '#152041' : 'transparent',
        color: active ? '#fff' : '#152041',
    }); };
    return (react_1.default.createElement(Box_1.default, { className: "container student-container-downloads" },
        showToggle && (react_1.default.createElement(Box_1.default, { sx: {
                display: 'flex',
                gap: '10px',
                width: '100%',
                maxWidth: '480px',
                margin: '0 auto 10px',
            } },
            react_1.default.createElement(Box_1.default, { component: "button", type: "button", onClick: function () { return setTab('sat'); }, sx: pillSx(tab === 'sat') },
                (0, Lang_js_1.__)('Soul Awareness Tapes'),
                " (",
                sats.length,
                ")"),
            react_1.default.createElement(Box_1.default, { component: "button", type: "button", onClick: function () { return setTab('discourse'); }, sx: pillSx(tab === 'discourse') },
                (0, Lang_js_1.__)('Discourses'),
                " (",
                discourses.length,
                ")"))),
        react_1.default.createElement(Box_1.default, { className: "downloads-grid" }, visible.map(function (download) {
            var _a = formatDownloadTitle(download.name, download.type, download.file, download.fileid), datePart = _a.datePart, titlePart = _a.titlePart;
            return (react_1.default.createElement(Box_1.default, { key: download.id, className: "downloads-grid-key", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '220px',
                    padding: '16px 0',
                } },
                react_1.default.createElement(Box_1.default, { component: "a", href: download.url, sx: {
                        textDecoration: 'none',
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        padding: '16px',
                    } },
                    react_1.default.createElement(Box_1.default, null, download.type === 'SAT' ? (react_1.default.createElement(Box_1.default, { sx: { minHeight: '48px' } },
                        datePart && (react_1.default.createElement(Typography_1.default, { sx: {
                                fontSize: '0.75rem',
                                textTransform: 'uppercase',
                                color: '#6c757d',
                                letterSpacing: '0.5px',
                                textAlign: 'right',
                                marginBottom: '4px',
                            } }, datePart)),
                        react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h5", sx: { marginBottom: '4px' } }, (0, Lang_js_1.__)('Soul Awareness Tapes')),
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '1rem', fontWeight: 500, marginTop: '8px' } }, titlePart),
                        download.expiredate && !download.expiredate.startsWith('0000') && (react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h6", sx: { marginTop: '4px' } },
                            (0, Lang_js_1.__)('Expires'),
                            ": ",
                            formatDate(download.expiredate))))) : (react_1.default.createElement(Typography_1.default, { sx: {
                            fontSize: '1rem',
                            fontWeight: 500,
                            minHeight: '40px',
                            marginBottom: '8px',
                        } }, download.title))),
                    react_1.default.createElement(Box_1.default, { sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end',
                            marginTop: '16px',
                        } },
                        react_1.default.createElement(Box_1.default, null,
                            react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h5", sx: { margin: 0 } },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDownload }),
                                "\u00A0",
                                (0, Lang_js_1.__)('Download'))),
                        react_1.default.createElement(Typography_1.default, { component: "strong", sx: {
                                backgroundColor: '#1c1c3c',
                                color: '#fff',
                                borderRadius: '4px',
                                padding: '4px 8px',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                            } }, (0, Lang_js_1.__)(download.type))))));
        }))));
}
exports.default = GetStudentDownloads;
var downloadsEl = document.getElementById('student-downloads');
if (downloadsEl) {
    (0, mountIsland_1.mountIsland)(downloadsEl, react_1.default.createElement(GetStudentDownloads, null));
}
